import type { ArgsFor, NamedArgs, PositionalArgs } from 'ember-modifier';
import Modifier from 'ember-modifier';

import { registerDestructor } from '@ember/destroyable';
import { action } from '@ember/object';

interface ICssVarsSignature {
  Element: HTMLElement;
  Args: {
    Named: Record<string, string | undefined>;
    Positional: [Record<string, string | undefined>];
  };
}

export default class CssVarsModifier extends Modifier<ICssVarsSignature> {
  elementToStyle?: HTMLElement;

  constructor(owner: any, args: ArgsFor<ICssVarsSignature>) {
    super(owner, args);
    registerDestructor(this, () => this.execute(args.positional, args.named, true));
  }

  modify(
    element: HTMLElement,
    positional: PositionalArgs<ICssVarsSignature>,
    named: NamedArgs<ICssVarsSignature>
  ): void {
    if (!this.elementToStyle) {
      this.elementToStyle = element;
    }
    this.execute(positional, named);
  }

  @action
  execute(
    positional: PositionalArgs<ICssVarsSignature>,
    named: NamedArgs<ICssVarsSignature>,
    remove: boolean = false
  ) {
    if (this.elementToStyle) {
      Object.entries(Object.assign({}, ...positional, named)).forEach(([key, val]) => {
        const k = key.startsWith('--') ? key : `--${key}`;
        if (!val || remove) {
          this.elementToStyle?.style.removeProperty(k);
        } else {
          this.elementToStyle?.style.setProperty(k, val);
        }
      });
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'css-vars': typeof CssVarsModifier;
  }
}
